import BubbleCommon from '@/pages/opinion/components/BubbleCommon';
import ChannelLabel from '@/pages/opinion/components/ChannelLabel';
import { NO_DATE } from '@/pages/opinion/constants';
import React from 'react';
import { useIntl } from 'umi';

export default function PlatformTitle({
  channelName,
  title = NO_DATE.EMPTY,
  className,
  iconTextMargin = 10,
  size = 24,
  children = null,
  titleIconEle = null,
  titleTips = null,
}: any) {
  const { formatMessage } = useIntl();

  return (
    <div className={`platform-title-wrapper ${className}`}>
      <div className="context-item-title">
        {titleIconEle || (
          <ChannelLabel
            channel_name={channelName}
            showText={false}
            iconStyle={{ width: size, height: size }}
            style={{ marginRight: iconTextMargin }}
          ></ChannelLabel>
        )}
        <span className="context-item-title-text">
          {formatMessage({ id: title })}
          {titleTips && (
            <BubbleCommon
              placement="top"
              childStyle={{ verticalAlign: 'text-top' }}
              tipsMap={titleTips}
            ></BubbleCommon>
          )}
        </span>
      </div>

      {children}
    </div>
  );
}
